var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var CacheDataSource_1;
import { injectable } from '../../Decorators/Injectable';
import { Observable } from '../../Observable/Observable';
import { getContentType, getExtension } from '../../../Helpers/ContentType/ContentType';
import { Platform } from 'react-native';
import * as FileSystem from 'expo-file-system';
const expireTime = 2592000000;
let CacheDataSource = CacheDataSource_1 = class CacheDataSource {
    static onUpdate(value, update) { }
    static setOnUpdate(fn) {
        CacheDataSource_1.onUpdate = fn;
    }
    constructor() {
        this.data = new Map();
        this.cache = {};
    }
    getAllFiles() {
        if (Platform.OS === 'web') {
            return Promise.resolve([]);
        }
        return new Promise((res) => {
            FileSystem.readAsStringAsync(FileSystem.cacheDirectory + CacheDataSource_1.cacheKey)
                .then(JSON.parse)
                .then(val => {
                if (!Array.isArray(val)) {
                    return res([]);
                }
                return res(val);
            })
                .catch((err) => {
                res([]);
            });
        });
    }
    getUUID() {
        return 'xxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = Math.random() * 16 | 0;
            const v = c == 'x'
                ? r
                : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    saveFile(key, data, date) {
        if (Platform.OS === 'web') {
            return Promise.resolve(null);
        }
        if (data === undefined || data === null) {
            if (this.data.has(key)) {
                this.data.delete(key);
                return this.getAllFiles()
                    .then(values => {
                    const item = values.find(x => x.key === key);
                    if (!item) {
                        return;
                    }
                    return FileSystem.deleteAsync(FileSystem.cacheDirectory + item.filename)
                        .then(() => FileSystem.writeAsStringAsync(FileSystem.cacheDirectory + CacheDataSource_1.cacheKey, JSON.stringify(values.filter(x => x.key !== key))));
                })
                    .then(() => null);
            }
            return Promise.resolve(null);
        }
        return this.registerFile(key, `${this.getUUID()}.json`, date)
            .then(item => {
            return FileSystem.writeAsStringAsync(FileSystem.cacheDirectory + item.filename, JSON.stringify(data))
                .then(() => item);
        });
    }
    registerFile(key, filename, date) {
        return this.getAllFiles()
            .then(items => {
            const index = items.findIndex(x => x.key === key);
            if (index > -1) {
                items[index].date = date;
                return FileSystem.writeAsStringAsync(FileSystem.cacheDirectory + CacheDataSource_1.cacheKey, JSON.stringify(items))
                    .then(() => items[index]);
            }
            const item = { key, date, filename };
            items.push(item);
            return FileSystem.writeAsStringAsync(FileSystem.cacheDirectory + CacheDataSource_1.cacheKey, JSON.stringify(items))
                .then(() => item);
        });
    }
    preloadCache() {
        if (Platform.OS === 'web') {
            return Promise.resolve(this.data);
        }
        return this.getAllFiles().then(downloads => {
            if (!Array.isArray(downloads)) {
                return this.data;
            }
            if (downloads.length <= 0) {
                return this.data;
            }
            return Promise.all(downloads.map(item => FileSystem.readAsStringAsync(FileSystem.cacheDirectory + item.filename).then(data => (Object.assign(Object.assign({}, item), { data: JSON.parse(data) }))).catch(() => (Object.assign(Object.assign({}, item), { data: null })))))
                .then(items => {
                items.forEach(item => {
                    if (this.data.has(item.key)) {
                        return;
                    }
                    const cache = {
                        data: new Observable(item.data),
                        expire: item.date
                    };
                    this.data.set(item.key, cache);
                });
                return this.data;
            });
        });
    }
    updateCacheObservable(update) {
        this.cache = Object.assign(Object.assign({}, this.cache), update);
        CacheDataSource_1.onUpdate(this.cache, update);
    }
    getExpireDate(time = expireTime) {
        return new Date().getTime() + time;
    }
    getKey(value) {
        return JSON.stringify(value);
    }
    updateMany(value, expiration) {
        Object.entries(value).forEach(([key, update]) => {
            this.upsertCache(key, update, expiration);
        });
        this.updateCacheObservable(value);
        return this.data;
    }
    updateCache(key, value, expiration) {
        const data = this.upsertCache(key, value, expiration);
        this.updateCacheObservable({ [key]: value });
        return data;
    }
    upsertCache(key, value, expiration) {
        const dataKey = this.getKey(key);
        if (this.data.has(dataKey)) {
            const cache = this.data.get(dataKey);
            cache.data.next(value);
            cache.expire = this.getExpireDate(expiration);
            this.data.set(dataKey, cache);
            this.saveFile(dataKey, value, cache.expire);
            return cache.data;
        }
        const cache = {
            data: new Observable(value),
            expire: this.getExpireDate(expiration)
        };
        this.saveFile(dataKey, value, cache.expire);
        this.data.set(dataKey, cache);
        return cache.data;
    }
    getCache(key, defaultData) {
        const dataKey = this.getKey(key);
        let cache = this.data.get(dataKey);
        if (!cache) {
            cache = {
                data: new Observable(defaultData),
                expire: defaultData !== undefined
                    ? this.getExpireDate()
                    : 0
            };
            this.data.set(dataKey, cache);
        }
        return cache;
    }
    removeCache(key) {
        const dataKey = this.getKey(key);
        if (this.data.has(dataKey)) {
            this.data.delete(dataKey);
            if (Platform.OS !== 'web') {
                return this.getAllFiles()
                    .then(values => {
                    const item = values.find(x => x.key === dataKey);
                    if (!item) {
                        return;
                    }
                    return FileSystem.deleteAsync(FileSystem.cacheDirectory + item.filename)
                        .then(() => FileSystem.writeAsStringAsync(FileSystem.cacheDirectory + CacheDataSource_1.cacheKey, JSON.stringify(values.filter(x => x.key !== dataKey))));
                });
            }
        }
        return Promise.resolve();
    }
    clear() {
        this.data.clear();
        return true;
    }
    downloadMany(values, options) {
        return Promise.all(values.map(value => this.download(value.key, value.url, options).catch((error) => {
            console.warn(error);
            return null;
        })));
    }
    download(key, url, options) {
        if (!url) {
            return Promise.reject(new Error('Download link is missing!'));
        }
        if (typeof url === 'number') {
            return Promise.resolve({ key, date: Date.now(), filename: url });
        }
        if (!url.startsWith('https://')) {
            return Promise.resolve({ key, date: Date.now(), filename: url });
        }
        return this.getAllFiles()
            .then(items => {
            const index = items.findIndex(x => x.key === key);
            if (index > -1 && items[index].data === url) {
                items[index].date = Date.now();
                return FileSystem.writeAsStringAsync(FileSystem.cacheDirectory + CacheDataSource_1.cacheKey, JSON.stringify(items))
                    .then(() => items[index]);
            }
            return getContentType(url)
                .then(contentType => {
                var _a;
                const overwrite = (_a = options === null || options === void 0 ? void 0 : options.overwrite) === null || _a === void 0 ? void 0 : _a.find(x => x.key === contentType);
                if (overwrite) {
                    contentType = overwrite.value;
                }
                const extention = getExtension(contentType);
                if (!extention) {
                    return Promise.reject(new Error('Invalid mime type!'));
                }
                return { key, date: Date.now(), filename: `${FileSystem.cacheDirectory}cds_file_${key}.${extention}`, data: url };
            })
                .then(value => {
                return FileSystem.downloadAsync(url, value.filename)
                    .then(() => value);
            })
                .then(value => {
                items = items.filter(x => x.key !== key);
                items.push(value);
                return FileSystem.writeAsStringAsync(FileSystem.cacheDirectory + CacheDataSource_1.cacheKey, JSON.stringify(items))
                    .then(() => value);
            });
        });
    }
};
CacheDataSource.cacheKey = 'json_cache.json';
CacheDataSource = CacheDataSource_1 = __decorate([
    injectable({ type: 'singleton' }),
    __metadata("design:paramtypes", [])
], CacheDataSource);
export { CacheDataSource };
